import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { GlobalConstants } from 'src/app/utils/global-constants';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.css'],
    standalone: false
})
export class UnsubscribeComponent {  
  showForm: boolean = true;

  constructor(
    public auth: AuthService,
    private router: Router,
    private notify:NotificationService
  ) {}

  submitform = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.emailPattern),
    ]),
    unsubscribeReasons: new FormControl('', [
      Validators.required,
    ]),
  });
  
  submit() {    
    if (this.submitform.valid) {
      const data = {
        reason: this.submitform.value.unsubscribeReasons,
        email: this.submitform.value.email,
        comments: "",
      };
      this.auth
        .UnSubscribe(data).subscribe((response) => {
            if (response?.succeeded) {
              this.showForm = false;
              // After 5 seconds, navigate to the home page
              setTimeout(() => {
                this.router.navigate(['/']);
              }, 10000);
            }
            else {             
              this.notify.showError(response.error.message);
            }
          }
        );
    }
  }
}
